import { useQuery } from 'react-query';
import { loadExpDetailsTemplate } from '../api/expDetailsTemplateApi';
import useExpDetailsRouteParams from '../useExpDetailsRouteParams';
import { SelectedExpDetailsTemplate } from '@experiment-details/types';
import { expDetailsTemplateKeys } from '../api/exp-details-template-key-factory';

type UseExpDetailsTemplateArgs = {
  templateId?: string | null;
};
const useExpDetailsProjectTemplate = ({
  templateId
}: UseExpDetailsTemplateArgs): SelectedExpDetailsTemplate => {
  const { projectId } = useExpDetailsRouteParams();

  const enabled = Boolean(templateId && projectId);

  const { data, isLoading } = useQuery(
    expDetailsTemplateKeys.projectTemplate(templateId ?? ''),
    () => {
      if (!templateId) return null;

      return loadExpDetailsTemplate({
        templateId,
        projectId
      });
    },
    {
      enabled
    }
  );

  return {
    templateData: data,
    isLoading
  };
};

export default useExpDetailsProjectTemplate;
